import { deleteProject } from "@/api/projects"
import { AiOutlineDelete } from "react-icons/ai"
import { 
    AlertDialog, 
    AlertDialogContent, 
    AlertDialogHeader, 
    AlertDialogTitle, 
    AlertDialogTrigger,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogAction,
    AlertDialogCancel
} from "@/components/ui/alert-dialog"
import { useState } from "react"

export default function DeleteProjectButton({ project_id }: { project_id: string }) {
    const [isDeleting, setIsDeleting] = useState(false)

    const handleDelete = async () => {
        setIsDeleting(true)
        try {
            const response = await deleteProject(project_id)
            if (response === 204) {
                // Project deleted successfully - you might want to refresh the page or update the parent component
                window.location.reload() // Simple solution, but consider using a callback prop instead
            }
        } catch (error) {
            console.error('Failed to delete project:', error)
        } finally {
            setIsDeleting(false)
        }
    }

    return (
        <AlertDialog>
            <AlertDialogTrigger className="rounded-2xl p-4 my-2 transition shadow-sm hover:shadow-md generic-button" asChild>
                <div className="flex flex-row gap-2 items-center">
                    <AiOutlineDelete />
                    Delete
                </div>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Delete Project</AlertDialogTitle>
                    <AlertDialogDescription>
                        Are you sure you want to delete this project? This action cannot be undone.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <AlertDialogAction 
                        onClick={handleDelete}
                        disabled={isDeleting}
                        className="bg-red-600 hover:bg-red-700"
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}